import classNames from 'classnames';
import Logo from './$.svg?react';
import './index.css';
import { RefObject, useRef, useSyncExternalStore } from 'react';

interface LogoLoaderProps {
  readonly active: boolean;
  readonly ref?: RefObject<HTMLDivElement | null>;
}

export function LogoLoader(props: LogoLoaderProps) {
  const ref = useRef<HTMLDivElement>(null);

  const active = useSyncExternalStore(
    (subscribe) => {
      const loader = props.ref?.current ?? ref.current;
      loader?.addEventListener('animationiteration', subscribe);

      return () => {
        loader?.removeEventListener('animationiteration', subscribe);
      };
    },
    () => props.active
  );
  
  return (
    <div ref={props.ref ?? ref} className={classNames('logo-loader', { active })}>
      <Logo />
    </div>
  );
}